var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',_vm._g({staticClass:"slds-dropdown__item",attrs:{"role":"presentation"}},_vm.$listeners),[_c('a',{attrs:{"role":"menuitem","tabindex":"0"}},[_c('span',{staticClass:"slds-truncate",attrs:{"title":_vm.label}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.decodeHtml(_vm.label)))]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }